import { Translation } from '@cds/betting-offer';

export interface SignedName {
    name: string;
    signature: string;
    nameAlternate?: string;
    signatureAlternate?: string;
}

export const createSignedName = function (input: Translation | string, preferLongName = false): SignedName {
    function isTranslation(st: Translation | string): st is Translation {
        return typeof st !== 'string';
    }
    if (isTranslation(input)) {
        const signedName = <SignedName>{
            name: preferLongName ? input.value || input.short : input.short || input.value,
            signature: preferLongName ? input.sign || input.shortSign : input.shortSign || input.sign,
        };

        if (input.alternate) {
            signedName.nameAlternate = preferLongName
                ? input.alternate.value || input.alternate.short
                : input.alternate.short || input.alternate.value;
            signedName.signatureAlternate = preferLongName
                ? input.alternate.sign
                    ? input.alternate.sign
                    : input.alternate.shortSign
                : input.alternate.short
                  ? input.alternate.shortSign
                  : input.alternate.sign;
        }

        return signedName;
    } else {
        return {
            name: input,
            signature: '',
        };
    }
};
